import consts from '@/consts';

export default class OauthUtils {
  static authorizationServerUrl() {
    return `https://sorare.com/oauth/authorize?client_id=${consts.CLIENT_ID}&redirect_uri=${consts.REDIRECT_URI}&response_type=code`;
  }
}
